<template>
  <div class="items" :class="item.isQuality ? 'isQuality':''" @click="handleJump(item)">
    <img v-if="item && item.isQuality" class="isQuality" src="../../../assets/images/home/quality-bg.png" alt="">
    <div class="items-cont">
      <div class="items-info">
        <div class="txt1">{{ item.title ? item.title : '' }}</div>
        <div class="txt3" v-if="isBriefItem">
          <div class="txt2"></div>
          <div class="readnum">
            <img src="../../../assets/images/home/search_view@2x.png" class="eyes" alt="">
            {{ item.readNum > 0 ? item.readNum : 0 }}
          </div>
        </div>
        <div class="cons" v-else>
          <div class="txt3">
            <div class="txt2" v-if="item.type === 2">
              讲师: {{ item && item.keynoteSpeaker }}
            </div>
            <div class="txt2" v-else-if="item.type === 3">
              作者: {{ item && item.keynoteSpeaker }}
            </div>
            <div class="txt2" v-else-if="item.type === 4">
              {{ item && item.keynoteSpeaker }}
            </div>
            <div class="readnum">
              <img src="../../../assets/images/home/search_view@2x.png" class="eyes" alt="">
              {{ item.readNum > 0 ? item.readNum : 0 }}
            </div>
          </div>
          <div class="txt2">
            医院：{{ item && item.hospitalName }}
          </div>
        </div>
        <div class="item-unlock"
             v-if="`${item.isUnlock}` === '1' && !item.myUnlock && `${item.type}` === '2'">
          <img src="../../../assets/images/data-base/unlock.png" class="icon-unlock" alt="">
          <span class="txt">{{ item && item.unlockCost }}积分解锁</span>
        </div>
        <slot name="Feedback"></slot>
      </div>
      <div class="items-cover-div">
        <img :src="item.coverUrl ? item.coverUrl : 'https://iep.jjmc.cn/bw/file/material/image/1933146816339349528.jpg'" class="cover" alt="">
        <div class="cover-tag" v-if="coverTag && !isMktGraphic">
          <img v-if="coverTag.icon" :src="coverTag.icon" class="icon-tag" alt="">
          {{ coverTag.name }}
        </div>
        <div class="cover-tag" v-else-if="item.type === 4">
          {{
            `${item.courseType}` === '1' ? 'RTC专区' : `${item.courseType}` === '2' ? '图文专区' : '心电图交流'
          }}
        </div>
      </div>
    </div>
    <page-search-dot-list :current-data="item" :cur-tab-key="curTabKey" ></page-search-dot-list>
    <dialogUnlock ref="dialogUnlock" @unlockSuccess="handleGotoDetails" :dataProps="dataProps"></dialogUnlock>
  </div>
</template>

<script>
import dialogUnlock from '@/components/dialogUnlock.vue'
import {setSha, traceClickURL} from '../../../utils/util'
import pageSearchDotList from '../components/pageSearchDotList.vue'
import {isScorm} from '../../../api/scorm'

const COVER_TAG_MAP = {
  1: {name: '文献解读', icon: require('../../../assets/images/home/search_article@2x.png')},
  2: {name: '课程', icon: require('../../../assets/images/home/search_course@2x.png')},
  3: {name: '病例', icon: require('../../../assets/images/home/search_case@2x.png')},
  5: {name: '视频', icon: require('../../../assets/images/video.png')},
  6: {name: 'PPT', icon: require('../../../assets/images/PPT.png')},
  7: {name: '文献', icon: require('../../../assets/images/journalArticles.png')},
  8: {name: '图文', icon: require('../../../assets/images/search_course_t.png')},
}

export default {
  components: {
    dialogUnlock,
    pageSearchDotList
  },
  computed: {
    itemType() {
      return Number(this.item && this.item.type)
    },
    isBriefItem() {
      return [1, 5, 6, 7, 8].includes(this.itemType)
    },
    coverTag() {
      return COVER_TAG_MAP[this.itemType] || null
    },
    // MKT图文：type 为 8 且有 fileId，封面角标不显示图标
    isMktGraphic() {
      return this.itemType === 8 && !!this.item.fileId
    }
  },
  data() {
    return {
      dataProps: {
        unlockContent: '兑换EP公开课课程',
        unlockTxt: '课程'
      },
    }
  },
  props: ['item', 'userInfo', 'curTabKey'],
  methods: {
    // 点击列表卡片跳转
    handleJump(item) {
      this.dataDetails = item
      if (`${item.isUnlock}` === '1' && !item.myUnlock && `${item.type}` === '2') {
        this.dataProps.baseId = item.baseId
        this.dataProps.unlockCost = item.unlockCost
        this.$refs.dialogUnlock.dailogShow = true
        return
      }
      this.handleGotoDetails()
    },
    setAIresult(callback) {
      const aiResultStr = sessionStorage.getItem('aiResult')
      let aiResult = null

      try {
        if (aiResultStr) {
          aiResult = JSON.parse(aiResultStr)
        } else {
          aiResult = {...this.AIresult} // 避免引用共享
        }
        callback(aiResult)
        sessionStorage.setItem('aiResult', JSON.stringify(aiResult))
      } catch (error) {
        console.error('解析或写入 aiResult 出错:', error)
      }
    },
    async handleGotoDetails() {
      let item = this.dataDetails
      const entrance = this.curTabKey === '2' ? 52 : 5
      window.sessionStorage.setItem('entrance', entrance)
      let openidBindli = `&unionid=${this.userInfo.unionId}&openid=${this.userInfo.iepOpenId}${setSha(`xxbiep${this.userInfo.iepOpenId}`)}`
      let trackParams = `&entrance=${entrance}&businessChannel=${entrance}`
      if (item.type === 1) { // 文献解读
        this.$router.push({
          path: '/articleDetails',
          query: {
            id: item.baseId,
            entrance: entrance,
            channel: entrance
          }
        })
      } else if (item.type === 7) { // 文献
        this.$router.push({
          path: '/journalArticle',
          query: {
            articleId: item.baseId,
            entrance: entrance,
            channel: entrance
          }
        })
      } else if (item.type === 8 && item.fileId) { // MKT图文（type === 8 && fileId有值）
        this.$router.push({
          path: '/technologyDetail',
          query: {
            fileId: item.fileId,
            entrance: entrance,
            channel: entrance
          }
        })
      } else if (item.type === 5 || item.type === 6 || item.type === 8) { // 视频、PPT、图文
        const materialId = item.materialId || (item.material && item.material.id) || item.baseId
        if (!materialId) {
          this.$toast('文件信息缺失')
          return
        }
        this.$router.push({
          path: '/filePreview',
          query: {
            materialId,
            entrance: entrance,
            channel: entrance
          }
        })
      } else if (item.type === 3) { // 病例
        setTimeout(() => {
          traceClickURL()
        })
        window.location.href = `${process.env.bingliUrl}/wap/index.html#/casedetails?id=${item.baseId}${openidBindli}${trackParams}`
      } else if (item.type === 2) { // 课程
        if (this.curTabKey === '2') {
          if (sessionStorage.getItem('aiResult')) {
            let aiResult = JSON.parse(`${sessionStorage.getItem('aiResult')}`)
            let newResult = aiResult.courseResult.map((res) => {
              if (res.baseId === item.baseId) {
                res.isUnlock = 0
                res.myUnlock = 1
              }
              return res
            })
            this.setAIresult((aiResult) => {
              aiResult['courseResult'] = newResult
            })
          }
        }
        const query = {
          courseId: item.baseId,
          entrance: entrance,
          channel: entrance,
          fromPage: 'search'
        }
        const isscorm = await isScorm(item.baseId)
        let path = '/courserDetails'
        if (isscorm.data) {
          path = '/scormCourseDetail'
        }
        this.$router.push({path, query})
      } else if (`${item.type}` === '4') { // 帖子
        this.$router.push({
          path: '/dccDetail',
          query: {
            postId: item.baseId,
            areaId: item.sectionId,
            entrancePage: 'search',
            entrance: entrance,
            channel: entrance,
            businessId: item.sectionId,
          }
        })
      }
    },
  }
}
</script>

<style scoped lang="less">
.items {
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  background: linear-gradient( 221deg, #FFFFFF 0%, #FFFFFF 100%);
  box-shadow: 0px 2px 8px 0px rgba(0,0,0,0.1);
  border-radius: 12px;
  padding: 10px;
  position: relative;

  &.isQuality {
    padding-top: 25px;
  }

  .isQuality {
    position: absolute;
    top: 0;
    right: 0;
    width: 141px;
  }

  .items-cont {
    display: flex;
    justify-content: space-between;
  }

  .items-info {
    flex: 1;
    margin-right: 26px;

    .txt1 {
      display: -webkit-box;
      -webkit-line-clamp: 2; //显示3行文字
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      color: #000000;
      font-family: PingFang HK, PingFang HK;
      font-weight: 500;
      font-size: 14px;
      margin-bottom: 5px;
    }

    .txt3 {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .readnum {
      text-align: left;
      color: #B1B1B1;
      font-size: 12px;
      line-height: 20px;
      display: flex;
      align-items: center;
      max-width: 100px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .txt2 {
      display: flex;
      align-items: center;
      font-size: 12px;
      color: #B1B1B1;
      line-height: 20px;
      flex: 1;
    }

    .eyes {
      width: 18px;
      display: block;
      margin-right: 3px;
    }

    .item-unlock {
      display: flex;
      align-items: center;
      height: 20px;
      margin-top: 2px;

      .icon-unlock {
        width: 10px;
        margin-right: 4px;
        display: block;
      }

      .txt {
        color: #EB1700;
        font-size: 10px;
      }
    }
  }

  .items-cover-div {
    width: 110px;
    height: 60px;
    position: relative;
    border-radius: 5px;
    overflow: hidden;

    .cover-tag {
      position: absolute;
      top: 0;
      left: 0;
      display: flex;
      align-items: center;
      border-radius: 5px 0 5px 0;
      background-color: rgba(0, 0, 0, .5);
      justify-content: center;
      height: 16px;
      font-size: 10px;
      color: #FFFFFF;
      padding: 0 5px;

      .icon-tag {
        width: 10px;
        height: 10px;
        margin-right: 2px;
      }
    }

    .cover {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: top;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/pageSearch/ListItem.vue